import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "../helpers/axios";
import { JourneyResponse } from "./dtos/journey.dto";

export const useJourneyData = (hash: string | null) => {
  return useQuery({
    queryKey: ["journey_data"],
    queryFn: async () => {
      if (hash) {
        const res = await axios.get<JourneyResponse>("/journey/me", {
          params: { hash },
        });
        return res.data;
      }
      const res = await axios.get<JourneyResponse>("/journey/me/anon");
      return res.data;
    },
    enabled: true,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });
};

export const useConsumeJourney = () => {
  return useMutation({
    mutationFn: async (hash: string) => {
      const res = await axios.post<JourneyResponse>("/journey/consume", {
        hash,
      });
      return res.data;
    },
  });
};

export const useAnswerPoll = () => {
  return useMutation({
    mutationFn: async ({ hash, answerIndex }: { hash: string; answerIndex: number }) => {
      const res = await axios.post("/journey/answer", {
        hash,
        answerIndex,
      });
      return res.data;
    },
  });
};

export const useRedeemJourney = () => {
  return useMutation({
    mutationFn: async (catalogTempId: string) => {
      const res = await axios.post("/answer-right/redeem", {
        catalogTempId,
      });
      return res.data;
    },
  });
};
